define('plugin/promotion/collection/PromotionCollection',['require','lib/collection/ServerPaginatedCollection','plugin/promotion/model/PromotionModel'],function (require) {

    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var PromotionModel = require('plugin/promotion/model/PromotionModel');

    /**
     * Promotion collection
     *
     * @class PromotionCollection
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/promotion/',
        model: PromotionModel

    });

});
